<template>
  <div class="publications">
    <v-container>
      <v-treeview v-if="items.length > 0" :items="items" item-key="id" open-all open-on-click>
      <!-- <v-treeview :items="items" item-key="id" open-all open-on-click> -->
        <template v-slot:label="{ item }">

          <div v-if="isYear(item.id)" class="heading text-h4 pl-4">
            {{ item.name }}
          </div>
          <li v-else class="mt-2 text-wrap text-break">
            {{ item.author }}, <a :href="item.url" target="_blank">"{{ item.title }}</a>",
            {{ item.publisher }}.
            <!-- {{ item.year }}年. -->
          </li>
        </template>
      </v-treeview>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Publications",
  data: () => ({
    items: []
  }),
  async created() {
    const res = await fetch('/papers.json');
    const data = await res.json();

    // yearの降順でソート
    const sorted = data.papers.sort((a, b) => b.year - a.year);

    // 年ごとのツリー構造へ変換
    const tree = {};
    sorted.forEach(d => {
      const yearKey = `${d.year}年`;
      if (!tree[yearKey]) {
        tree[yearKey] = { id: yearKey, name: yearKey, children: [] };
      }
      tree[yearKey].children.push({
        id: `${d.year}-${d.name}`,  // idがないので代替キー
        title: d.name,
        author: d.author,
        url: d.url,
        publisher: d.publisher,
        year: d.year
      });
    });

    this.items = Object.values(tree).sort((a, b) => b.id.localeCompare(a.id));
  },
  methods: {
    isYear(id) {
      return id && id.toString().match("年");
    }
  }
};
</script>

<style scoped>
.heading {
  border-bottom: 2px solid #000;
  margin-top: 10px;
  margin-bottom: 20px; 
}
</style>